exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ds-card-description{color:var(--ds-color-london-10);font-family:var(--ds-type-system-sans);font-size:var(--ds-type-scale-0);font-weight:400;line-height:var(--ds-type-leading-lower);margin-top:.25rem}.ds-card-description em{font-style:italic}", ""]);

// exports
exports.locals = {
	"ds-card-description": "ds-card-description"
};